import { render } from "./PageSpace.vue?vue&type=template&id=cc7b469c&ts=true"
import script from "./PageSpace.ts?vue&type=script&lang=ts&external"
export * from "./PageSpace.ts?vue&type=script&lang=ts&external"

import "./PageSpace.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__